/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToQuery } from '../../mutators/add-meta';
import { addMetaToMutation } from '../../mutators/add-meta';
import type {
  AuthorizeSSHKeyRequest,
  DeauthorizeSSHKeyRequest,
  DeleteSSHKeyRequest,
  Error,
  ImportSSHKeyRequest,
  ListSSHKeysResponse,
  ListSiteSshKeysParams,
  SSHKeyResponse,
  SiteID,
} from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Returns paginated SSH public keys registered for the site, including name, authorization status, and file reference. Search by name or filename.
 * @summary List SSH keys
 */
export const listSiteSshKeys = (
  id: SiteID,
  params?: ListSiteSshKeysParams,
  signal?: AbortSignal
) => {
  return customFetch<ListSSHKeysResponse>({
    url: `/v1/sites/${id}/ssh/keys`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListSiteSshKeysQueryKey = (id?: SiteID, params?: ListSiteSshKeysParams) => {
  return [`/v1/sites/${id}/ssh/keys`, ...(params ? [params] : [])] as const;
};

export const getListSiteSshKeysQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteSshKeys>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteSshKeysParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteSshKeys>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteSshKeysQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteSshKeys>>> = ({ signal }) =>
    listSiteSshKeys(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/ssh/keys`,
      operationId: 'app.controllers.ssh_keys_controller.list_site_ssh_keys',
      operationName: 'listSiteSshKeys',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listSiteSshKeys>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteSshKeysQueryResult = NonNullable<Awaited<ReturnType<typeof listSiteSshKeys>>>;
export type ListSiteSshKeysQueryError = Error;

export function useListSiteSshKeys<
  TData = Awaited<ReturnType<typeof listSiteSshKeys>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSiteSshKeysParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteSshKeys>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteSshKeys>>,
          TError,
          Awaited<ReturnType<typeof listSiteSshKeys>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteSshKeys<
  TData = Awaited<ReturnType<typeof listSiteSshKeys>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteSshKeysParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteSshKeys>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteSshKeys>>,
          TError,
          Awaited<ReturnType<typeof listSiteSshKeys>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteSshKeys<
  TData = Awaited<ReturnType<typeof listSiteSshKeys>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteSshKeysParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteSshKeys>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List SSH keys
 */

export function useListSiteSshKeys<
  TData = Awaited<ReturnType<typeof listSiteSshKeys>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteSshKeysParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteSshKeys>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteSshKeysQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSiteSshKeysSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteSshKeys>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteSshKeysParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteSshKeys>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteSshKeysQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteSshKeys>>> = ({ signal }) =>
    listSiteSshKeys(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/ssh/keys`,
      operationId: 'app.controllers.ssh_keys_controller.list_site_ssh_keys',
      operationName: 'listSiteSshKeys',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSiteSshKeys>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteSshKeysSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteSshKeys>>
>;
export type ListSiteSshKeysSuspenseQueryError = Error;

export function useListSiteSshKeysSuspense<
  TData = Awaited<ReturnType<typeof listSiteSshKeys>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSiteSshKeysParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteSshKeys>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteSshKeysSuspense<
  TData = Awaited<ReturnType<typeof listSiteSshKeys>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteSshKeysParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteSshKeys>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteSshKeysSuspense<
  TData = Awaited<ReturnType<typeof listSiteSshKeys>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteSshKeysParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteSshKeys>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List SSH keys
 */

export function useListSiteSshKeysSuspense<
  TData = Awaited<ReturnType<typeof listSiteSshKeys>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteSshKeysParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteSshKeys>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteSshKeysSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Imports a public SSH key with a filename label. The key is stored on the server and will need to be authorized before it can be used for login.
 * @summary Add an SSH public key
 */
export const createSiteSshKey = (
  id: SiteID,
  importSSHKeyRequest: ImportSSHKeyRequest,
  signal?: AbortSignal
) => {
  return customFetch<SSHKeyResponse>({
    url: `/v1/sites/${id}/ssh/keys`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: importSSHKeyRequest,
    signal,
  });
};

export const getCreateSiteSshKeyMutationOptions = <
  TError = SSHKeyResponse | Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSiteSshKey>>,
    TError,
    { id: SiteID; data: ImportSSHKeyRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSiteSshKey>>,
  TError,
  { id: SiteID; data: ImportSSHKeyRequest },
  TContext
> => {
  const mutationKey = ['createSiteSshKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSiteSshKey>>,
    { id: SiteID; data: ImportSSHKeyRequest }
  > = props => {
    const { id, data } = props ?? {};

    return createSiteSshKey(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/ssh/keys` },
    {
      operationId: 'app.controllers.ssh_keys_controller.create_site_ssh_key',
      operationName: 'createSiteSshKey',
    }
  );

  return customOptions;
};

export type CreateSiteSshKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSiteSshKey>>
>;
export type CreateSiteSshKeyMutationBody = ImportSSHKeyRequest;
export type CreateSiteSshKeyMutationError = SSHKeyResponse | Error;

/**
 * @summary Add an SSH public key
 */
export const useCreateSiteSshKey = <TError = SSHKeyResponse | Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSiteSshKey>>,
      TError,
      { id: SiteID; data: ImportSSHKeyRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSiteSshKey>>,
  TError,
  { id: SiteID; data: ImportSSHKeyRequest },
  TContext
> => {
  const mutationOptions = getCreateSiteSshKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes the SSH key identified by name in the request body from the server. The key can no longer be used for SSH access after deletion.
 * @summary Permanently remove an SSH key
 */
export const deleteSiteSshKey = (id: SiteID, deleteSSHKeyRequest: DeleteSSHKeyRequest) => {
  return customFetch<SSHKeyResponse>({
    url: `/v1/sites/${id}/ssh/keys`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteSSHKeyRequest,
  });
};

export const getDeleteSiteSshKeyMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSiteSshKey>>,
    TError,
    { id: SiteID; data: DeleteSSHKeyRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSiteSshKey>>,
  TError,
  { id: SiteID; data: DeleteSSHKeyRequest },
  TContext
> => {
  const mutationKey = ['deleteSiteSshKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSiteSshKey>>,
    { id: SiteID; data: DeleteSSHKeyRequest }
  > = props => {
    const { id, data } = props ?? {};

    return deleteSiteSshKey(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/ssh/keys` },
    {
      operationId: 'app.controllers.ssh_keys_controller.delete_site_ssh_key',
      operationName: 'deleteSiteSshKey',
    }
  );

  return customOptions;
};

export type DeleteSiteSshKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSiteSshKey>>
>;
export type DeleteSiteSshKeyMutationBody = DeleteSSHKeyRequest;
export type DeleteSiteSshKeyMutationError = Error;

/**
 * @summary Permanently remove an SSH key
 */
export const useDeleteSiteSshKey = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSiteSshKey>>,
      TError,
      { id: SiteID; data: DeleteSSHKeyRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSiteSshKey>>,
  TError,
  { id: SiteID; data: DeleteSSHKeyRequest },
  TContext
> => {
  const mutationOptions = getDeleteSiteSshKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Authorizes a previously imported key so it can be used for passwordless SSH access to the site's hosting account.
 * @summary Enable an SSH key for login
 */
export const authorizeSiteSshKey = (
  id: SiteID,
  authorizeSSHKeyRequest: AuthorizeSSHKeyRequest,
  signal?: AbortSignal
) => {
  return customFetch<SSHKeyResponse>({
    url: `/v1/sites/${id}/ssh/keys/authorize`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: authorizeSSHKeyRequest,
    signal,
  });
};

export const getAuthorizeSiteSshKeyMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authorizeSiteSshKey>>,
    TError,
    { id: SiteID; data: AuthorizeSSHKeyRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authorizeSiteSshKey>>,
  TError,
  { id: SiteID; data: AuthorizeSSHKeyRequest },
  TContext
> => {
  const mutationKey = ['authorizeSiteSshKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authorizeSiteSshKey>>,
    { id: SiteID; data: AuthorizeSSHKeyRequest }
  > = props => {
    const { id, data } = props ?? {};

    return authorizeSiteSshKey(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/ssh/keys/authorize` },
    {
      operationId: 'app.controllers.ssh_keys_controller.authorize_site_ssh_key',
      operationName: 'authorizeSiteSshKey',
    }
  );

  return customOptions;
};

export type AuthorizeSiteSshKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof authorizeSiteSshKey>>
>;
export type AuthorizeSiteSshKeyMutationBody = AuthorizeSSHKeyRequest;
export type AuthorizeSiteSshKeyMutationError = Error;

/**
 * @summary Enable an SSH key for login
 */
export const useAuthorizeSiteSshKey = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authorizeSiteSshKey>>,
      TError,
      { id: SiteID; data: AuthorizeSSHKeyRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof authorizeSiteSshKey>>,
  TError,
  { id: SiteID; data: AuthorizeSSHKeyRequest },
  TContext
> => {
  const mutationOptions = getAuthorizeSiteSshKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Revokes authorization for a key without deleting it. The key remains on the server but cannot be used for SSH login until re-authorized.
 * @summary Disable an SSH key
 */
export const deauthorizeSiteSshKey = (
  id: SiteID,
  deauthorizeSSHKeyRequest: DeauthorizeSSHKeyRequest,
  signal?: AbortSignal
) => {
  return customFetch<SSHKeyResponse>({
    url: `/v1/sites/${id}/ssh/keys/deauthorize`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: deauthorizeSSHKeyRequest,
    signal,
  });
};

export const getDeauthorizeSiteSshKeyMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deauthorizeSiteSshKey>>,
    TError,
    { id: SiteID; data: DeauthorizeSSHKeyRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deauthorizeSiteSshKey>>,
  TError,
  { id: SiteID; data: DeauthorizeSSHKeyRequest },
  TContext
> => {
  const mutationKey = ['deauthorizeSiteSshKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deauthorizeSiteSshKey>>,
    { id: SiteID; data: DeauthorizeSSHKeyRequest }
  > = props => {
    const { id, data } = props ?? {};

    return deauthorizeSiteSshKey(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/ssh/keys/deauthorize` },
    {
      operationId: 'app.controllers.ssh_keys_controller.deauthorize_site_ssh_key',
      operationName: 'deauthorizeSiteSshKey',
    }
  );

  return customOptions;
};

export type DeauthorizeSiteSshKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deauthorizeSiteSshKey>>
>;
export type DeauthorizeSiteSshKeyMutationBody = DeauthorizeSSHKeyRequest;
export type DeauthorizeSiteSshKeyMutationError = Error;

/**
 * @summary Disable an SSH key
 */
export const useDeauthorizeSiteSshKey = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deauthorizeSiteSshKey>>,
      TError,
      { id: SiteID; data: DeauthorizeSSHKeyRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deauthorizeSiteSshKey>>,
  TError,
  { id: SiteID; data: DeauthorizeSSHKeyRequest },
  TContext
> => {
  const mutationOptions = getDeauthorizeSiteSshKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns full details for one SSH key by filename or name, including public key content, authorization status, and created or modified timestamps.
 * @summary Get SSH key details
 */
export const findSiteSshKey = (id: SiteID, name: string, signal?: AbortSignal) => {
  return customFetch<SSHKeyResponse>({
    url: `/v1/sites/${id}/ssh/keys/${name}`,
    method: 'GET',
    signal,
  });
};

export const getFindSiteSshKeyQueryKey = (id?: SiteID, name?: string) => {
  return [`/v1/sites/${id}/ssh/keys/${name}`] as const;
};

export const getFindSiteSshKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteSshKey>>,
  TError = Error,
>(
  id: SiteID,
  name: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteSshKey>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteSshKeyQueryKey(id, name);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteSshKey>>> = ({ signal }) =>
    findSiteSshKey(id, name, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, name },
    {
      url: `/v1/sites/${id}/ssh/keys/${name}`,
      operationId: 'app.controllers.ssh_keys_controller.find_site_ssh_key',
      operationName: 'findSiteSshKey',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof findSiteSshKey>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteSshKeyQueryResult = NonNullable<Awaited<ReturnType<typeof findSiteSshKey>>>;
export type FindSiteSshKeyQueryError = Error;

export function useFindSiteSshKey<
  TData = Awaited<ReturnType<typeof findSiteSshKey>>,
  TError = Error,
>(
  id: SiteID,
  name: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteSshKey>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteSshKey>>,
          TError,
          Awaited<ReturnType<typeof findSiteSshKey>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSshKey<
  TData = Awaited<ReturnType<typeof findSiteSshKey>>,
  TError = Error,
>(
  id: SiteID,
  name: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteSshKey>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteSshKey>>,
          TError,
          Awaited<ReturnType<typeof findSiteSshKey>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSshKey<
  TData = Awaited<ReturnType<typeof findSiteSshKey>>,
  TError = Error,
>(
  id: SiteID,
  name: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteSshKey>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get SSH key details
 */

export function useFindSiteSshKey<
  TData = Awaited<ReturnType<typeof findSiteSshKey>>,
  TError = Error,
>(
  id: SiteID,
  name: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteSshKey>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteSshKeyQueryOptions(id, name, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindSiteSshKeySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteSshKey>>,
  TError = Error,
>(
  id: SiteID,
  name: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSshKey>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteSshKeyQueryKey(id, name);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteSshKey>>> = ({ signal }) =>
    findSiteSshKey(id, name, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, name },
    {
      url: `/v1/sites/${id}/ssh/keys/${name}`,
      operationId: 'app.controllers.ssh_keys_controller.find_site_ssh_key',
      operationName: 'findSiteSshKey',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findSiteSshKey>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteSshKeySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteSshKey>>
>;
export type FindSiteSshKeySuspenseQueryError = Error;

export function useFindSiteSshKeySuspense<
  TData = Awaited<ReturnType<typeof findSiteSshKey>>,
  TError = Error,
>(
  id: SiteID,
  name: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSshKey>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSshKeySuspense<
  TData = Awaited<ReturnType<typeof findSiteSshKey>>,
  TError = Error,
>(
  id: SiteID,
  name: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSshKey>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSshKeySuspense<
  TData = Awaited<ReturnType<typeof findSiteSshKey>>,
  TError = Error,
>(
  id: SiteID,
  name: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSshKey>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get SSH key details
 */

export function useFindSiteSshKeySuspense<
  TData = Awaited<ReturnType<typeof findSiteSshKey>>,
  TError = Error,
>(
  id: SiteID,
  name: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSshKey>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteSshKeySuspenseQueryOptions(id, name, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
